import React from 'react';

const Sorting: React.FC<React.PropsWithChildren> = () => (
  <>
    <path d="M13.9401 2.66078H9.2201L11.5801 0.300781L13.9401 2.66078ZM9.2501 17.3708H13.9101L11.5801 19.7008L9.2501 17.3708ZM5.1001 4.27078L0.600098 15.7308H2.4401L3.3601 13.2808H8.4701L9.3901 15.7308H11.2301L6.7401 4.27078H5.1001ZM3.9701 11.6408L5.9101 6.46078L7.8501 11.6408H3.9701ZM14.7301 14.1408H20.8501V15.7308H12.3201V14.4408L18.2401 5.88078H12.3601V4.28078H20.6601V5.54078L14.7301 14.1408Z" />
  </>
);

export default Sorting;
